import { render } from "./LanguageSelectionPage.vue?vue&type=template&id=432b734a&scoped=true&ts=true"
import script from "./LanguageSelectionPage.vue?vue&type=script&lang=ts"
export * from "./LanguageSelectionPage.vue?vue&type=script&lang=ts"

import _style_0 from "./LanguageSelectionPage.vue?vue&type=style&index=0&id=432b734a&inline&scoped=true&lang=scss"

import exportComponent from "/Users/philippniestroj/Desktop/AgenturPhilipp/ProductFinder/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]],['__scopeId',"data-v-432b734a"]])

export default __exports__